import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MessageService } from 'primeng/api';
import { CommonService } from 'src/app/services/common.service';
import { AuthService } from 'src/app/services/auth.service';
import { ContactService } from 'src/app/services/contact.service';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { Capacitor } from '@capacitor/core';
import { Subject } from 'rxjs';

/* const { Browser } = Plugins */
@Injectable({
  providedIn: 'root'
})

export class SendMoneyService {
  contacts: any = []
  caReasons = []
  caPaymentMethods = []
  paymentdetails = {
    payment_id:'',
    celo_to_address:'',

  };
  isdcBankTransactionfaild = false
  isMarkPurpose = false
  isMarkTransaction = false
  isMarkConfirm = false
  isMarkComplete = false
  purpose
  receiver
  transactionDetails
  fundingSource
  requestedSendingAmount = null
  isAcknowlodgingRequest = false
  confirmScreen = false
  selectedCAPaymentMethod
  payment_account_type = 'bank'
  usa_trans_details
  success_usa
  qr_code
  qr_amount
  qr_bool
  ps_locations
  current_page
  last_page
  prev_disabled = true
  next_disabled = false
  transaction_error = new Subject();
  constructor(
    private iab: InAppBrowser,
    private http: HttpClient, private router: Router, private messageService: MessageService, private common: CommonService, public auth: AuthService, private contactService: ContactService) {
    // this.setContacts()
    // if(localStorage.getItem('user')['country_id'] == 39) {
    this.common.showLoader()
    this.getcareason().subscribe((res: any) => {
      //console.log(res)
      this.caReasons = res.reasons
      //console.log("reasons",this.caReasons)
      this.common.stopLoader()
    })
    // if(this.auth.user?.country_id == 39 && this.auth.user?.mob_verified && this.auth.user?.email_verified_at){
    // this.getcaPaymentOptions().subscribe((res:any)=>{
    //   this.caPaymentMethods=res.data
    // },err=>{
    // })
    // }

    // }
  }

  getcareason() {
    return this.http.get(environment.api_link_careasons + '/show_transfer_reasons.json')
  }

  getcaPaymentOptions() {
    return this.http.get(environment.api_link + "/api/auth/active-payment-options")
  }

 sendModeny() {
    console.log("sendModeny call hua mai");
    if (this.auth.user.country_id == 233) {
      let payout_method = 'BANK_DEPOSIT';
      if (this.receiver.transaction_type == 'Mobile') {
        payout_method = 'WALLET'
      }
      else if (this.receiver.transaction_type == 'Bank') {
        payout_method = 'BANK_DEPOSIT'

      }
      let finaldata = {
        ...this.purpose,
        ...this.receiver,
        ...this.transactionDetails,
        ...{ payout_method: payout_method }

      }
      finaldata.new_trans_fee = this.transactionDetails.fee_amount
      finaldata.receiver_id = finaldata.recipient_id
      finaldata.transaction_type = "individual"
      this.common.showLoader();
      console.log("finaldata");
      console.log(finaldata);
      return this.http.post(environment.api_link + '/api/auth/send_money', finaldata).subscribe((res: any) => {
        let name = `${this.receiver.first_name} ${this.receiver.last_name}`
        localStorage.setItem('recvName', name)
        //console.log(res)
        if (res.status == 'error') {
          this.success_usa = false
        }
        else if (res.status == 'success') {
          this.success_usa = true
          this.usa_trans_details = res.machpay_response
          if (this.transactionDetails.coupon_id) {
            this.usedCoupon(this.transactionDetails.coupon_id, this.auth.user.id).subscribe(res => {
              //console.log(res)
            })
          }
        }
        this.receiver = null
        this.transactionDetails = null
        this.purpose = null
        this.fundingSource = null
        this.router.navigateByUrl("/send-money/step5")
        /* this.confirmScreen=false */
        this.common.stopLoader()
      }, err => {
        let errorKeys = Object.keys(err.error.errors);
        errorKeys.forEach(key => {
          //console.log(key)
          let value = err.error.errors[key][0];
          this.messageService.add({ severity: 'error', summary: 'Error', detail: value });
          //console.log(value);
        });
        //console.log(err)
        this.common.stopLoader()
      })
    }
    if (this.auth.user.country_id == 39) {
      console.log("this.auth.user.country_id  MIL GAYA ");
      console.log(this.selectedCAPaymentMethod.gateway_name);

      if (this.selectedCAPaymentMethod.gateway_name == "PSI Gate") {
        let finaldata = { ...this.purpose, ...this.receiver, ...this.transactionDetails, ...this.selectedCAPaymentMethod }
        let data: any = { receiver_id: this.receiver.id, sending_amount: +finaldata.sending_amt, payment_type: finaldata.payment_option, reason_code: finaldata.reason_code, payment_gateway_id: finaldata.payment_gateways_id, ...{ payment_account_type: this.payment_account_type }, discounted_amount: finaldata.discounted_amount, new_trans_fee: finaldata.fee_amount, coupon_id: this.transactionDetails.coupon_id }
        data.transaction_type = "individual"
        this.common.showLoader()
        return this.http.post(environment.api_link + '/api/auth/send-money-via-psi', data).subscribe((res: any) => {
          //console.log(res)
          localStorage.setItem('customerRefNo', res.customerRefNo)
          localStorage.setItem('recvName', this.receiver.payee_name)
          if (this.transactionDetails.coupon_id)
            localStorage.setItem('cc', this.transactionDetails.coupon_id)
          let payByPSID
          if (res.payment_type == "debit_card" || res.payment_type == "credit_card") {
            payByPSID = { StoreKey: environment.PSI_STORE_KEY_CC, SubTotal: res.total_amount, Email: environment.BCC_MAIL_ADDRESS, PaymentType: "CC", CardAction: 0, CustomerRefNo: res.customerRefNo }
          }
          if (res.payment_type == "offline") {
            payByPSID = { StoreKey: environment.PSI_STORE_KEY_DB, SubTotal: res.total_amount, Email: environment.BCC_MAIL_ADDRESS, PaymentType: "DB", CardAction: 0, CustomerRefNo: res.customerRefNo }
          }
          this.postInNewTab(payByPSID)
          /* this.router.navigateByUrl("/send-money/step5") */
          /* this.confirmScreen=false */
          this.common.stopLoader()
        }, err => {
          let errorKeys = Object.keys(err.error.errors);
          errorKeys.forEach(key => {
            //console.log(key)
            let value = err.error.errors[key][0];
            this.messageService.add({ severity: 'error', summary: 'Error', detail: value });
            //console.log(value);
          });
          //console.log(err)
          this.common.stopLoader()
        })
      }
      else if (this.selectedCAPaymentMethod.gateway_name == "DC Bank" || this.selectedCAPaymentMethod.gateway_name == "Celo Payment") {
        //console.log("inside dc")
        console.log("this.transactionDetails");
        console.log(this.transactionDetails);

        if (this.selectedCAPaymentMethod.payment_option == "offline") {
          let data: any = {
            receiver_id: this.receiver.id,
            sending_amount: +this.transactionDetails.sending_amt,
            reason_code: this.purpose.reason_code,
            payment_gateway_id: this.selectedCAPaymentMethod.payment_gateways_id,
            ...{ payment_account_type: this.payment_account_type },
            discounted_amount: +this.transactionDetails.discounted_amount,
            new_trans_fee: this.transactionDetails.fee_amount,
            coupon_id: this.transactionDetails.coupon_id,
            celo_wallet_number: this.transactionDetails.celoData.celoWalletNumber,
          }
          data.transaction_type = "individual"
          //console.log(data)
         this.sendViaDCOffline(data)
          .subscribe((res: any) => {
            //console.log(res,"api response");

            this.paymentdetails.payment_id = res.payment_id
            this.paymentdetails.celo_to_address = res.celo_to_address
            //console.log("payment& address",this.paymentdetails);
            
            this.auth.get_monthly_limit(this.auth.user.id)
            if (this.selectedCAPaymentMethod.gateway_name == "Celo Payment") {
              this.transactionDetails.celo_total_amount = +(+res.celo_total_amount).toFixed(2)
              this.router.navigateByUrl("/send-money/step6/" + res.trans_key)
            } else {
              this.transactionDetails.final_amount_interac = +(+res.total_amount).toFixed(2)
              this.router.navigateByUrl("/send-money/step5/" + res.trans_key)
            }
            this.common.stopLoader()
          }, err => {
            //console.log("transection error again",err.error.message);
            this.common.stopLoader();
            this.transaction_error.next(err.error.message)
            let errorKeys = Object.keys(err.error.errors);
            errorKeys.forEach(key => {
              let value = err.error.errors[key][0];
              this.messageService.add({ severity: 'error', summary: 'Error', detail: value });
              //console.log("transaction error",value);
            });
            //console.log(err)
            this.common.stopLoader()
          })

          console.log("Outside Send Money API this.transaction_error");
          console.log(this.transaction_error);
        }
        else if (this.selectedCAPaymentMethod.payment_option == "bank") {
          this.common.showLoader()
          //console.log("bank")
          let data: any = {
            receiver_id: this.receiver.id,
            sending_amount: +this.transactionDetails.sending_amt,
            reason_code: this.purpose.reason_code,
            payment_gateway_id: this.selectedCAPaymentMethod.payment_gateways_id,
            ...{ payment_account_type: this.payment_account_type },
            discounted_amount: this.transactionDetails.discounted_amount,
            new_trans_fee: this.transactionDetails.fee_amount
          }
          data.transaction_type = "individual"
          if (!this.auth.user.interac_email_id) {
            //console.log("creating account")
            this.createDCAccount().subscribe(res => {
              //console.log(res)
              this.sendmoneyViaDCBank(data).subscribe((res: any) => {
                //console.log(res)
                if (!res.error_code) {
                  this.isdcBankTransactionfaild = true
                }
                this.common.stopLoader()
                this.auth.get_monthly_limit(this.auth.user.id)
                this.router.navigateByUrl("/send-money/step5/")
              }, err => {
                let errorKeys = Object.keys(err.error.errors);
                errorKeys.forEach(key => {
                  //console.log(key)
                  let value = err.error.errors[key][0];
                  this.messageService.add({ severity: 'error', summary: 'Error', detail: value });
                  //console.log(value);
                });
                //console.log(err)
                this.common.stopLoader()
              })
            }, err => {
              let errorKeys = Object.keys(err.error.errors);
              errorKeys.forEach(key => {
                //console.log(key)
                let value = err.error.errors[key][0];
                this.messageService.add({ severity: 'error', summary: 'Error', detail: value });
                //console.log(value);
              });
              //console.log(err)
              this.common.stopLoader()
            })
          } else {
            //console.log("email presenr")
            this.sendmoneyViaDCBank(data).subscribe(res => {
              //console.log(res)
              this.common.stopLoader()
              this.auth.get_monthly_limit(this.auth.user.id)
              this.router.navigateByUrl("/send-money/step5")
            }, err => {
              let errorKeys = Object.keys(err.error.errors);
              errorKeys.forEach(key => {
                //console.log(key)
                let value = err.error.errors[key][0];
                this.messageService.add({ severity: 'error', summary: 'Error', detail: value });
                //console.log(value);
              });
              //console.log(err)
              this.common.stopLoader()
            })
          }

        }
      }
      else if (this.selectedCAPaymentMethod.gateway_name == "Payment Source") {
        let data: any = {
          receiver_id: this.receiver.id,
          sending_amount: +this.transactionDetails.sending_amt,
          reason_code: this.purpose.reason_code,
          payment_gateway_id: this.selectedCAPaymentMethod.payment_gateways_id,
          ...{ payment_account_type: this.payment_account_type },
          discounted_amount: +this.transactionDetails.discounted_amount,
          new_trans_fee: this.transactionDetails.fee_amount,
          coupon_id: this.transactionDetails.coupon_id
        }
        data.transaction_type = "individual"
        //console.log(data)
        this.sendMoneyViaPaymentSource(data).subscribe((res: any) => {
          this.qr_code = res.qr_code
          this.qr_amount = res.total_amount
          this.auth.get_monthly_limit(this.auth.user.id)
          this.getLocationByPostalCode(this.auth.user.zip_code, 1).subscribe((res: any) => {
            this.ps_locations = res.data.data
            this.router.navigateByUrl("/send-money/step5?payment-source-qr=true")
          }, err => {
            this.ps_locations = []
            this.router.navigateByUrl("/send-money/step5?payment-source-qr=true")
          })
          // this.getLocations(res.tid).subscribe((res:any) => {
          //   // console.log(res)
          //   this.ps_locations = res.data
          //   this.router.navigateByUrl("/send-money/step5?payment-source-qr=true")
          // },err =>{
          //   this.ps_locations = []
          //   this.router.navigateByUrl("/send-money/step5?payment-source-qr=true")
          // })


        }, err => {
          //console.log(err)
          this.common.stopLoader()
        })

      }
    }
  }

  getConversionRate(source_currency, country_id, amount = 1, paymentGatewayId = null) {

    let paymentGatewayIdCondition = paymentGatewayId ? `&payment_gateway_id=${paymentGatewayId}` : '';
    /* /api/get-exchange-rate?source_currency=cad&country_id=kes&source_amount=1 */
    return this.http.get(environment.api_link + '/api/get-exchange-rate?source_currency=' + source_currency + "&country_id=" + country_id + "&source_amount=" + amount + `&celo=1&` + `${paymentGatewayIdCondition}`)
  }

  getTransactionFees(source_currency, destination_currency, source_amount = 1) {
    /*   source_currency="usd"
      destination_currency="kes" */
    /* /api/get-exchange-rate?source_currency=cad&destination_currency=kes&source_amount=1 */
    //console.log(source_currency, destination_currency)
    return this.http.get(environment.api_link + '/api/get-exchangeRate-fees?source_currency=' + source_currency + "&destination_currency=" + destination_currency + "&source_amount=" + source_amount)
  }

  getFundingSource() {
    return this.http.post(environment.api_link + '/api/auth/fundingSources', {})
  }

  onPsiSuccessResult(data) {
    return this.http.post(environment.api_link + '/api/auth/psi-success-result', data)
  }

  getDebitAuthorization() {
    return this.http.get(environment.api_link + '/api/auth/machpay_states_details')

  }

  postInNewTab(obj) {
    let myInterval = setInterval(() => {
      this.http.get(`${environment.api_link}/api/trans_details/${obj.CustomerRefNo}`).subscribe((res: any) => {
        //console.log(res)
        if (res.trans_status) {
          if (res.trans_status == 'Successful') {
            this.auth.get_monthly_limit(this.auth.user.id)
            this.router.navigateByUrl('/send-money/step5?success=Successful')
            clearInterval(myInterval)
            browser.close()
          }
          else if (res.trans_status == 'Unsuccessful') {
            this.router.navigateByUrl('/send-money/step5?error=Unsuccessful')
            clearInterval(myInterval)
            browser.close()
          }

        }
      })
    }, 1500)
    let options: any = {
      location: 'yes',//Or 'no' 
      hidden: 'no', //Or  'yes' 
      hideurlbar: 'yes',//Or 'no'
      toolbar: 'yes',
      hidenavigationbuttons: 'yes',
      mediaPlaybackRequiresUserAction: 'yes',
      allowInlineMediaPlayback: 'yes'
    };
    let target = "_self"
    if (Capacitor.getPlatform() === 'android') {
      target = "_blank"
    }

    const browser = this.iab.create(environment.api_link + `/psi-html?PaymentType=${obj['PaymentType']}&SubTotal=${obj['SubTotal']}&CustomerRefNo=${obj['CustomerRefNo']}`, target, options);
    browser.on('exit').subscribe(() => {
      clearInterval(myInterval)
      this.common.stopLoader()
    }, err => {
      console.error(err);
    });
  }

  sendViaDCOffline(data) {
    return this.http.post(environment.api_link + '/api/auth/send-money-via-dc-interac', data)
  }
  
  createDCAccount() {
    return this.http.post(environment.api_link + '/api/auth/save-interac-email', { email: this.auth.user.email })
  }

  sendmoneyViaDCBank(data) {
    return this.http.post(environment.api_link + '/api/auth/send-money-via-dc-bank', data)
  }

  sendMoneyViaPaymentSource(data) {
    return this.http.post(environment.api_link + '/api/auth/send-money-via-payment-source', data)
  }

  setContacts(page = 1) {
    this.common.showLoader()
    this.contactService.getRecipients(page).subscribe((res: any) => {
      // this.contacts = [...this.contacts, ...res.data.data]
      this.contacts = res.data.data
      this.current_page = res.data.current_page
      this.last_page = res.data.last_page
      if (this.current_page == 1)
        this.prev_disabled = true
      else
        this.prev_disabled = false

      if (this.current_page == this.last_page)
        this.next_disabled = true
      else
        this.next_disabled = false
      this.common.stopLoader()
    })
  }

  goTo(step) {
    if (step == 'step1') {
      this.router.navigateByUrl("/send-money/step1")
      this.isMarkPurpose = false
      this.isMarkTransaction = false
      this.isMarkConfirm = false
    }
    if (step == 'step2') {
      this.router.navigateByUrl("/send-money/step2")
      this.isMarkPurpose = true
      this.isMarkTransaction = false
      this.isMarkConfirm = false
    }
    if (step == 'step3') {
      this.router.navigateByUrl("/send-money/step3")
      this.isMarkPurpose = true
      this.isMarkTransaction = true
      this.isMarkConfirm = false
    }
    if (step == 'step4') {
      this.router.navigateByUrl("/send-money/step4")
      this.isMarkPurpose = true
      this.isMarkTransaction = true
      this.isMarkConfirm = true
    }
    if (step == 'step5') {
      //this.router.navigateByUrl("/send-money/step5")
    }
  }

  resetData() {
    this.isdcBankTransactionfaild = false
    this.isMarkPurpose = false
    this.isMarkTransaction = false
    this.isMarkConfirm = false
    this.isMarkComplete = false
    this.purpose = null
    this.receiver = null
    this.transactionDetails = []
    this.fundingSource = null
    this.requestedSendingAmount = null
    this.isAcknowlodgingRequest = false
    this.confirmScreen = false
    this.selectedCAPaymentMethod = null
    this.payment_account_type = 'bank'

  }

  checkPromo(promo, amount, rec_country, gateway_id) {
    // {{local_url}}/api/auth/check-coupon?coupon_code=lhxnjw6s47i
    return this.http.get(`${environment.api_link}/api/auth/check-coupon?coupon_code=${promo}&sending_amt=${amount}&receiver_country=${rec_country}&gateway_id=${gateway_id}&platform=web`)
  }

  usedCoupon(coupon_code, user_id) {
    let data = {
      coupon_id: coupon_code,
      user_id: user_id
    }
    return this.http.post(`${environment.api_link}/api/auth/user-coupon-detail`, data)
  }

  cancelTransaction(trans_id) {
    return this.http.get(`${environment.api_link}/api/auth/cancel_transaction/${trans_id}`)
  }

  // getLocations(id){
  //   return this.http.get(`${environment.api_link}/api/location-list`, {
  //     params:{
  //       txn_id : id
  //     }
  //   })
  // }

  getLocationByPostalCode(postal, page) {
    return this.http.get(`${environment.api_link}/api/list-location?postal_code=${postal}&type=individual&page=${page}`)
  }
}





